"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { SessionProvider } from "next-auth/react";
import { FormProvider, useForm } from "react-hook-form";
import { ProfileProvider } from "@/context/ProfileProvider";
import { SpecialPermitFormValues } from "@/types/specialPermitForm";
import { BASE_PATH } from "@/constants";
import GTM from "@/components/gtm";
import { getSessionStorage } from "@/utils/store";
import useAppInsights from "@/hooks/useAppInsights";
import { CXPThemeProvider, GlobalStyle } from "@ops-gsic/cxp-component-library-react";
import { cxpTheme } from "@/theme/AppTheme";
import { InboxProvider } from "@/context/InboxProvider";
import { useAppConfig } from "@/context/AppConfigProvider";
export default function ClientProviders(t0) {
  const $ = _c(17);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mode: "onSubmit",
      shouldUnregister: false,
      reValidateMode: "onChange",
      defaultValues: {
        hasPurchasedPermit: "",
        isVehicleFromOntario: "",
        insuranceCompany: "",
        insurancePolicyNumber: "",
        hasInsurance: false,
        contact: {}
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const methods = useForm(t1);
  const {
    reset
  } = methods;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = `${BASE_PATH}/api/auth`.replace(/\/+/g, "/");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const nextAuthApiBasePath = t2;
  const {
    appConfig,
    loading
  } = useAppConfig();
  const gtmID = appConfig?.gtmTrackingId || "";
  let t3;
  let t4;
  if ($[2] !== reset) {
    t3 = () => {
      const sessionData = getSessionStorage();
      if (sessionData) {
        reset(sessionData);
      }
    };
    t4 = [reset];
    $[2] = reset;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  useAppInsights(appConfig?.appInsightsConnectionString as string, appConfig?.appInsightsRoleName as string);
  let t5;
  if ($[5] !== gtmID || $[6] !== loading) {
    t5 = !loading && gtmID && <GTM gtmID={gtmID} />;
    $[5] = gtmID;
    $[6] = loading;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <GlobalStyle fontsPath="/special-permit-ui/fonts" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== children) {
    t7 = <CXPThemeProvider defaultTheme={cxpTheme}>{t6}{children}</CXPThemeProvider>;
    $[9] = children;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== methods || $[12] !== t7) {
    t8 = <ProfileProvider><InboxProvider><FormProvider {...methods}>{t7}</FormProvider></InboxProvider></ProfileProvider>;
    $[11] = methods;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <SessionProvider refetchInterval={300} refetchOnWindowFocus={true} refetchWhenOffline={false} basePath={nextAuthApiBasePath}>{t5}{t8}</SessionProvider>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}